export const SETTINGS_DISPATCHES = {
  currentDefaultSettings: "CURRENT_DEFAULT_SETTINGS",
  updateDefaultSettings: "UPDATE_DEFAULT_SETTINGS",
  currentCoordinatorSettings: "CURRENT_COORDINATOR_SETTINGS",
  updateCoordinatorSettings: "UPDATE_COORDINATOR_SETTINGS",
  currentMemberSettings: "CURRENT_MEMBER_SETTINGS",
  updateMemberSettings: "UPDATE_MEMBER_SETTINGS",
  clearMemberSettings: "CLEAR_MEMBER_SETTINGS"
};

function settingsReducer(state: any, { type, payload }: any) {
  switch (type) {
    case SETTINGS_DISPATCHES.currentDefaultSettings:
      return {
        ...state,
        default: {
          loaded: true,
          data: payload
        }
      };
    case SETTINGS_DISPATCHES.updateDefaultSettings:
      return {
        ...state,
        default: {
          ...state.default,
          data: {
            ...state.default.data,
            system: {
              ...state.default.data?.system,
              settings: {
                ...state.default.data?.system?.settings,
                ...payload
              }
            }
          },
          loaded: true
        }
      };
    case SETTINGS_DISPATCHES.currentCoordinatorSettings:
      return {
        ...state,
        coordinator: {
          loaded: true,
          data: payload
        }
      };
    case SETTINGS_DISPATCHES.updateCoordinatorSettings: {
      return {
        ...state,
        coordinator: {
          ...state.coordinator,
          data: {
            ...state.coordinator.data,
            system: {
              ...state.coordinator.data.system,
              settings: {
                ...state.coordinator.data.system.settings,
                ...payload.system.settings
              }
            }
          }
        }
      };
    }
    case SETTINGS_DISPATCHES.currentMemberSettings:
      return {
        ...state,
        member: {
          memberId: payload.memberId,
          data: {
            system: {
              settings: payload.settings
            }
          },
          loaded: true,
        }
      };
    case SETTINGS_DISPATCHES.updateMemberSettings:
      return {
        ...state,
        member: {
          ...state.member,
          data: {
            ...state.member.data,
            system: {
              ...state.member.data?.system,
              settings: {
                ...state.member.data?.system?.settings,
                ...payload
              }
            }
          },
          loaded: true
        }
      };
    case SETTINGS_DISPATCHES.clearMemberSettings:
      return {
        ...state,
        member: {
          memberId: null,
          loaded: false,
          data: null
        }
      };
    default:
      return state;
  }
}

export default settingsReducer;